import React from 'react';
import classes from './style.module.scss';
import Logo from '../Logo/Logo';
import VK from '../../media/vk_logo.svg';
import Instagram from '../../media/instagram.svg';
import Whatsup from '../../media/whats.svg';
import Telegram from '../../media/telegram.svg';
const Info = () => {
    return (
        <div className={classes.container}>
            <div>
                <div>
                    <h3>
                        Приветствуем Вас в нашем клубе в самом сердце города
                        Ногинск.
                    </h3>
                    <p>
                        Клуб предлагает уникальную атмосферу и возможность
                        провести время с друзьями, соревнуясь в игре в бильярд.
                        В баре можно заказать напитки и закуски, чтобы
                        насладиться игрой в полной мере. Бильярдный клуб - это
                        идеальное место для проведения различных мероприятий. Мы
                        предлагаем услуги по проведению дней рождений,
                        корпоративных вечеринок и других мероприятий. Мы
                        гарантируем, что гости нашего клуба получат незабываемые
                        впечатления и проведут время с удовольствием.
                    </p>
                    <div className={classes.bottomInfo}>
                        <Logo />
                        <div>
                            <a
                                rel="noreferrer"
                                target="_blank"
                                href="https://vk.com/legendbogorodskiy"
                            >
                                <img src={VK} alt="vk" />
                            </a>
                            <a
                                rel="noreferrer"
                                target="_blank"
                                href="https://instagram.com/legendbogorodskiy?igshid=MzRlODBiNWFlZA=="
                            >
                                <img src={Instagram} alt="instagram" />
                            </a>
                            <a
                                rel="noreferrer"
                                target="_blank"
                                href="https://t.me/legendbogorodskiy"
                            >
                                <img src={Telegram} alt="telegram" />
                            </a>
                            <a
                                rel="noreferrer"
                                target="_blank"
                                href="https://chat.whatsapp.com/J30xu9VU7Xq4xpB50yAz0K"
                            >
                                <img src={Whatsup} alt="whatsup" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Info;
